import React, { useState, useEffect } from "react";
import {
  setStartDate,
  setEndDate,
  runQueryPagoda,
} from "../../../redux/action";
import { RootState } from "../../../redux/reducer";
import { connect, ConnectedProps } from "react-redux";
import moment from "moment";
import _ from "lodash";
import { PagodaByStoreEvents } from "../events.config";
import { EventTypes } from "../../eventtype.model";
import CommonTable from "../../../components/Table/CommonTable";
import { dataComparator } from "../../kayJwellers/helper";
import CustomDateRangePicker from "../../kayJwellers/KJTabs/CustomDateRangePicker";
import { downloadCSV } from "../../kayJwellers/helper";
import axios from "axios";
import { installationData } from "../../../common/api";
import useClasses from "../../../common/UseClasses";
import { Button, Grid, Typography } from "@mui/material";

type PropsFromRedux = ConnectedProps<typeof connector>;
type ByStoreTabProps = PropsFromRedux & {};

const useStyles = () => ({
  container: {
    height: 440,
  },

  csvButton: {
    backgroundColor: "rgba(107,147,57,1)",
    height: 30,
    width: 80,
    paddingLeft: 10,
    paddingRight: 10,
    borderRadius: 5,
    color: "white",
    textDecorationLine: "none",
    marginBottom: 5,
    fontSize: 12,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});

const PagodaByStoreTab: React.FC<ByStoreTabProps> = ({
  startDateObj,
  endDateObj,
  setStartDate,
  setEndDate,
  runQueryPagoda,
  dateRange,
  ...rest
}) => {
  useEffect(() => {
    // getInitialData(); /* function call to retrieve data once's component is loaded */
  }, []);

  // const classes = useStyles();
  const classes: any = useClasses(useStyles);

  const headers: any = [
    { label: "Store ID", key: "store_id" },
    { label: "Store Name", key: "storeName" },
    { label: "Event Count", key: "value" },
    { label: "% Change", key: "change" },
    { label: "Installation Date", key: "installation_date" },
    { label: "Device", key: "device" },
    { label: "City", key: "city" },
    { label: "State", key: "state" },
    { label: "Operation Status", key: "operation_status" },
  ];

  const [eventsData, setEventsData] = useState<{ [key: string]: any[] }>({});
  const [totalCount, setTotalCount] = useState<{ [key: string]: number }>({});

  const getInitialData = async () => {
    await getSelectedAPIList();
  };

  let count: { [key: string]: number } = {};

  const getSelectedAPIList = async () => {

    // Fetch installation data 
    let installationdata: any[] = []
    installationData().then((res:any) => installationdata = res?.data)


    const startDate = moment(startDateObj).format("YYYYMMDD");
    const endDate = moment(endDateObj).format("YYYYMMDD");

    const startDate1 = moment(dateRange.selection1.startDate).format(
      "YYYYMMDD"
    );
    const endDate1 = moment(dateRange.selection1.endDate).format("YYYYMMDD");

    const startDate2 = moment(dateRange.selection2.startDate).format(
      "YYYYMMDD"
    );
    const endDate2 = moment(dateRange.selection2.endDate).format("YYYYMMDD");

    let query = `SELECT event_name,param1.value.string_value AS store_id, param.value.string_value AS storeName, count(1) as value
        FROM \`pagoda-cms-prod.analytics_211897923.events_*\`,
        UNNEST(event_params) AS param , UNNEST(event_params) AS param1 WHERE (param.key = 'vv_store_name') AND param1.key = 'vv_store_id'
        AND event_date >= '${startDate1}' AND  event_date <= '${endDate1}'
        group by 1,2,3`;

    const startDateRangeResult: any = await runQueryPagoda({ query }, false);

    query = `SELECT event_name,param1.value.string_value AS store_id, param.value.string_value AS storeName, count(1) as value
            FROM \`pagoda-cms-prod.analytics_211897923.events_*\`,
            UNNEST(event_params) AS param , UNNEST(event_params) AS param1 WHERE (param.key = 'vv_store_name') AND param1.key = 'vv_store_id'
            AND event_date >= '${startDate2}' AND  event_date <= '${endDate2}'
            group by 1,2,3`;

    const endDateRangeResult: any = await runQueryPagoda({ query }, false);

    const data = dataComparator(startDateRangeResult, endDateRangeResult);

    query = `SELECT event_name, param.value.string_value AS storeName, count(1) as value FROM 
                    \`pagoda-cms-prod.analytics_211897923.events_*\`, 
                    UNNEST(event_params) AS param WHERE param.key = 'vv_store_name' 
                    AND event_date >= '${startDate}' AND  event_date <= '${endDate}'
                    group by 1,2 order by value desc`; /* Query to fetch data (event name, store name, respective count) on basis
                                      event timestamp and and storename */

    const allEventsData: any = {};

    //const result: any = await runQueryPagoda({ query }, false); /* function call to fire query into backend and fetch data */
    data.forEach((row: any) => {
      /* loop over data retrieved */

      let eventobj: EventTypes[];
      eventobj = PagodaByStoreEvents.filter((eventtype: any) =>
        eventtype.events.includes(row.event_name)
      ); /* match event with events defined in events.config file */

      if (eventobj && eventobj.length) {
        const label: string = eventobj[0].label;

        if (!allEventsData[label]) {
          allEventsData[label] = [];
          const { event_name, ...obj } = row;
          allEventsData[label].push(obj);
          count[label] = row["value"];
        } else {
          const { event_name, ...obj } = row;
          allEventsData[label].push(obj);
          count[label] += row["value"];
        }
      }
    });
     // Compare stores with database store data 
     if (Object.keys(allEventsData).length > 0 && installationdata?.length > 0) {
      for (let key in allEventsData) {
        allEventsData[key].forEach((item: any) => {
          installationdata.forEach((dataItem: any) => {
            if (item.store_id === dataItem.store_id.toString()) {
              item.installation_date = dataItem.installation_date
              item.device = dataItem.device
              item.city = dataItem.city
              item.state = dataItem.state
              item.operation_status = dataItem.operation_status
            }
          })
        })
        // sort each object key data by date
        allEventsData[key] = allEventsData[key].sort(
          (a: any, b: any) => {
            if (a.installation_date === undefined || a.installation_date === null) {
              return 1
            }
            if (b.installation_date === undefined || b.installation_date === null) {
              return -1
            }
            const newA = a.installation_date.split('/').reverse().join('-');
            const newB = b.installation_date.split('/').reverse().join('-');
            return +new Date(newA) - +new Date(newB)
          }
        )
      }
    }

    //  console.log(allEventsData)

    setEventsData(
      allEventsData
    ); /* update state variable with  all table formatted data */
    setTotalCount(count); /* update state variable with total count of table */

    //console.log("allData==>",allData)
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: 30,
          marginBottom: 50,
        }}
      >
        <CustomDateRangePicker />

        <Button
          variant="contained"
          color="secondary"
          style={{
            width: 150,
            height:40,
            marginLeft: 20,
          }}
          onClick={() => getInitialData()}
        >
          Apply
        </Button>
      </div>
      <Grid container spacing={4}>
        {eventsData
          ? Object.keys(eventsData)?.map((row: string, i: number) => {
              // loop over each table format dynamically
              const tableData: any = {};
              tableData["tableHeader"] = [...headers];
              tableData["tableRow"] = [...eventsData[row]];

              return (
                <Grid item md={12} xs={6} lg={6} key={i}>
                  <div style={{ display: "flex" }}>
                    <div style={{ flex: 1 }}>
                      <Typography style={{ fontSize: 14, fontWeight: 800 }} color="primary">
                        {`${row}`} <br />{" "}
                        {`(Total Count : ${totalCount[row]}) `}
                      </Typography>
                    </div>
                    <div style={{ justifyContent: "flex-end" }}>
                      <Button
                        variant="contained"
                        color="primary"
                          sx={{
                          height:40,
                          width:200,
                          textAlign: "center",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginBottom:3
                          }}
                        onClick={() =>
                          downloadCSV(eventsData[row], row, headers)
                        }
                      >
                        {" "}
                        Download CSV
                      </Button>
                    </div>
                  </div>
                  {eventsData[row] ? (
                    <CommonTable tableData={tableData} />
                  ) : null}
                </Grid>
              );
            })
          : null}
      </Grid>
    </div>
  );
};

const mapState = (state: RootState) => ({
  isUserLoggedIn: state.user.isUserLoggedIn,
  startDateObj: state.report.startDate,
  endDateObj: state.report.endDate,
  dateRange: state.report.dateRange,
});

const connector = connect(mapState, {
  setStartDate,
  setEndDate,
  runQueryPagoda,
});

export default connector(PagodaByStoreTab);
